module.exports = __webpack_public_path__ + "img/kphybbanner.0ba8bb8a.png";